import React, { useContext } from "react";
import {AuthContext} from '../../../context/authContext'
import "./Sidebar.css";
import {
  FaHome,
  FaBox,
  FaMap,
  FaChartBar,
  FaInbox,
  FaTruck,
} from "react-icons/fa";
import { TbMessageReportFilled } from "react-icons/tb";
import { RiAccountCircleFill } from "react-icons/ri";
const Sidebar = ({NavigationStatus, setNavigationStatus}) => {
const {user}=useContext(AuthContext)

  return (
    <div className="sidebar">
      <h1 className="logo">Dashboard</h1>
      <hr />
      <div className="menu-container">
<div className="menu">
        <p className="section-title">Content</p>
        <ul className="contant-button-list">
          <li
            className={NavigationStatus === "Home" ? "Active" : ""}
            onClick={() => setNavigationStatus("Home")}
          >
            <FaHome className="icon" /> <p>Home</p>
          </li>
          <li
            className={NavigationStatus === "Calendar" ? "Active" : ""}
            onClick={() => setNavigationStatus("Calendar")}
          >
            <FaMap className="icon" />
            <p>Calendar</p>
          </li>
          <li
            className={NavigationStatus === "MySubmissions" ? "Active" : ""}
            onClick={() => setNavigationStatus("MySubmissions")}
          >
            <FaBox className="icon" /> <p>Weekly</p> 
          </li>
          <li
            className={NavigationStatus === "AllSubmissions" ? "Active" : ""}
            onClick={() => setNavigationStatus("AllSubmissions")}
          >
            <FaBox className="icon" /> <p>Submissions</p>
          </li>
          <li
            className={NavigationStatus === "ProblemManagement" ? "Active" : ""}
            onClick={() => setNavigationStatus("ProblemManagement")}
          >
            <FaChartBar className="icon" /> <p>Problems </p>
          </li>
        </ul>
      </div>

      <div className="menu">
        <p className="section-title">Managment</p>
        <ul>
          {user?.role.trim().toLowerCase()==="admin"?<li
            className={NavigationStatus === "Accounts" ? "Active" : ""}
            onClick={() => setNavigationStatus("Accounts")}
          >
            <RiAccountCircleFill className="icon" />
            <p>Accounts</p>{/*  <span className="badge">9+</span> */}
          </li>:null}
          <li
            className={NavigationStatus === "Reports" ? "Active" : ""}
            onClick={() => setNavigationStatus("Reports")}
          >
            <TbMessageReportFilled className="icon" />
            <p>Reports</p>
          </li>
        </ul>
      </div>
      </div>
      
    </div>
  );
};

export default Sidebar;
